module.exports = __webpack_public_path__ + "static/media/status.34e458dc.svg";